export const svgIcons = [
	{ id: 'tag', color: '#838383', backgroundColor: '#FFFFFF' },
	{ id: 'c-revenue', color: '#838383', backgroundColor: '#FFFFFF' },
	{ id: 'expense', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'doller-return', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'new-order', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'customers', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'sale', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'profit', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'orders', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'user-visitor', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'course-1', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'arrowright', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'bag', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'pencil', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'stroke-task-arrow', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-task-arrow', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'eye', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'mouth', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-view', color: '#EBEBEB', backgroundColor: '#FFFFFF' },
	{ id: 'c-profit', color: '#FFAA05', backgroundColor: '#FFFFFF' },
	{ id: 'c-invoice', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-home', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-widget', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-layout', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-project', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-file', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-board', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-ecommerce', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-email', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-chat', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-user', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-subscribe', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-sitemap', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-api', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-reports', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-bookmark', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-contact', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-task', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-calendar', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-social', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-to-do', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-search', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-form', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-table', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-ui-kits', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-bonus-kit', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-animation', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-icons', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-button', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-charts', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-landing-page', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-sample-page', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-internationalization', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-price', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-starter-kit', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-error', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-authenticate', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-coming-soon', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-email-temp', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-gallery', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-blog', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-faq', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-job-search', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-learning', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-maps', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-editors', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-knowledgebase', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'fill-support-tickets', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'call', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'general-setting', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'seller-commission', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'wallet-point', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'setting-refund', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'complete-deliver', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'setting-analytics', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'setting-payment', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'activation-setting', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'treading', color: '#7366FF', backgroundColor: '#FFFFFF' },
	{ id: 'fill-star', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'attchment', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'file-upload', color: '#7366FF', backgroundColor: '#FFFFFF' },
	{ id: 'file-upload1', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'edit-content', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'trash1', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'starbox-icon', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'camera', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'stroke-msg', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'stroke-folder', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'ppt-folder', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'img-folder', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'download-files', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'close-btn', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'project-search', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'project-target', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'project-activity', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'project-setting', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'project-rectangle', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'filter-option', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'project-msg', color: '#1E1E1E', backgroundColor: '#FFFFFF' },
	{ id: 'earning2', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'earning3', color: '#65C15C', backgroundColor: '#FFFFFF' },
	{ id: 'earning4', color: '#40B8F5', backgroundColor: '#FFFFFF' },
	{ id: 'crm-user', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'crm-lead', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'crm-deal', color: null, backgroundColor: '#FFFFFF' },
	{ id: 's-facebook', color: '#2F84F4', backgroundColor: '#FFFFFF' },
	{ id: 's-instagram', color: '#FC971E', backgroundColor: '#FFFFFF' },
	{ id: 's-pinterest', color: '#838383', backgroundColor: '#FFFFFF' },
	{ id: 's-twitter', color: '#57B9F6', backgroundColor: '#FFFFFF' },
	{ id: 'analytics-view', color: '#838383', backgroundColor: '#FFFFFF' },
	{ id: 'analytics-session', color: '#54BA4A', backgroundColor: '#FFFFFF' },
	{ id: 'analytics-rate', color: '#FC564A', backgroundColor: '#FFFFFF' },
	{ id: 'analytics-duration', color: '#FFAA05', backgroundColor: '#FFFFFF' },
	{ id: 'analytics-retention', color: '#40B8F5', backgroundColor: '#FFFFFF' },
	{ id: 'stop-watch', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'hire-candidate', color: '#838383', backgroundColor: '#FFFFFF' },
	{ id: 'gross-salary', color: '#FFAA05', backgroundColor: '#FFFFFF' },
	{ id: 'new-employee', color: '#65C15C', backgroundColor: '#FFFFFF' },
	{ id: 'hr-pen', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'hr-trash', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'stroke-activity', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'view-member', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'stroke-note', color: '#52526C', backgroundColor: '#FFFFFF' },
	{ id: 'attach-img', color: '#396CE8', backgroundColor: '#FFFFFF' },
	{ id: 'total-project', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'stroke-package', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'stroke-progress-delivery', color: null, backgroundColor: '#FFFFFF' },
	{ id: 'stroke-delivered', color: '#FFAA05', backgroundColor: '#FFFFFF' },
	{ id: 'chainlink', color: '#FBA134', backgroundColor: '#FFFFFF' },
	{ id: 'person-group', color: '#FF3364', backgroundColor: '#FFFFFF' },
	{ id: 'delivery-box', color: '#FFA941', backgroundColor: '#FFFFFF' },
	{ id: 'marketing', color: '#54BA4A', backgroundColor: '#FFFFFF' }
];
export function commonCurrencyChart(data: {
	color: string[];
	dropShadowColor: string;
	label: string[];
	widgetYSeries: number[];
}) {
	return {
		series: [
			{
				data: data.widgetYSeries
			}
		],
		chart: {
			width: 110,
			height: 110,
			type: 'line',
			toolbar: {
				show: false
			},
			offsetY: 10,
			dropShadow: {
				enabled: true,
				enabledOnSeries: undefined,
				top: 6,
				left: 0,
				blur: 6,
				color: data.dropShadowColor,
				opacity: 0.3
			}
		},
		grid: {
			show: false
		},
		colors: data.color,
		stroke: {
			width: 2,
			curve: 'smooth'
		},
		labels: data.label,
		markers: {
			size: 0
		},
		xaxis: {
			// type: 'datetime',
			axisBorder: {
				show: false
			},
			axisTicks: {
				show: false
			},
			labels: {
				show: false
			},
			tooltip: {
				enabled: false
			}
		},
		yaxis: {
			axisBorder: {
				show: false
			},
			axisTicks: {
				show: false
			},
			labels: {
				show: false
			}
		},
		legend: {
			show: false
		},
		tooltip: {
			marker: {
				show: false
			},
			x: {
				show: false
			},
			y: {
				show: false,
				labels: {
					show: false
				}
			}
		},
		responsive: [
			{
				breakpoint: 1790,
				options: {
					chart: {
						width: 100,
						height: 100
					}
				}
			},
			{
				breakpoint: 1661,
				options: {
					chart: {
						width: '100%',
						height: 100
					}
				}
			}
		]
	};
}

export var revenue = {
	counter: 40000,
	pr: 50,
	name: 'Revenue',
	font: 'dark',
	icon: 'c-revenue',
	suffix: 'Dhs'
};

export var profit = {
	font: 'warning',
	counter: 80,
	pr: 20,
	name: 'Profit',
	icon: 'c-profit',
	suffix: '%'
};

export var defaultWidget = {
	category: 'widget',
	subCategory: 'simple',
	icon: svgIcons[0],
	valueColor: '#1f1f1f',
	titleColor: '#939393',
	chartColor: '#1f1f1f'
};
export var progressChartWidget = {
	...defaultWidget,
	title: 'Bitcoin',
	code: 'BTC',
	price: 2143,
	profit: 50,
	profit_type: 'profit',
	suffix: 'warning',
	chart_details: commonCurrencyChart({
		color: ['#1f1f1f'],
		dropShadowColor: '#1f1f1f',
		label: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov'],
		widgetYSeries: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
	})
};
